import format from 'date-fns/format'
import DateFormats from '../../constants/DateFormats'

export const formatDate = (date: Date, dateFormat: DateFormats = DateFormats.DATE) => format(date, dateFormat)
export const formatDateTime = (date: Date) => format(date, DateFormats.DATE_WITH_TIME)
export const formatTime = (date: Date) => format(date, DateFormats.TIME)
export const formatIsoDate = (date: Date) => format(date, DateFormats.ISO_DATE)
